
import { StringHelper } from "../../../../../utilities/contracts/string-helper";

export class AnalyticsItem {
  analyticsItemID: number;
  name: string;
  description: string;
  analyticsType: string;
  analyticsSource: string;
  analyticsCategory: string;
  analyticsOutput: string;
  directoryRoleData: string;
  projectTypeData: string;
  url: string;
  lookerIframeUrl: string;
  lookerIframeId: number;
  lookerPermissionSet: string;
  projectId: string;
  organizationList: string;
  constructor(options: {
    analyticsItemID: number;
    name: string;
    description: string;
    analyticsType: string;
    analyticsSource: string;
    analyticsCategory: string;
    analyticsOutput: string;
    directoryRoleData: string;
    projectTypeData: string;
    url: string;
    lookerIframeUrl: string;
    lookerIframeId: number;
    lookerPermissionSet: string;
    projectId: string;
    organizationList: string;


  }) {
    this.analyticsItemID = options.analyticsItemID;
    this.name = StringHelper.clean(options.name);
    this.description = StringHelper.clean(options.description);
    this.analyticsType = StringHelper.clean(options.analyticsType);
    this.analyticsSource = StringHelper.clean(options.analyticsSource);
    this.analyticsCategory = StringHelper.clean(options.analyticsCategory);
    this.analyticsOutput = StringHelper.clean(options.analyticsOutput);
    this.directoryRoleData = StringHelper.clean(options.directoryRoleData);
    this.projectTypeData = StringHelper.clean(options.projectTypeData);
    this.url = StringHelper.clean(options.url);
    this.lookerIframeUrl = StringHelper.clean(options.lookerIframeUrl);
    this.lookerIframeId = options.lookerIframeId;
    this.lookerPermissionSet = StringHelper.clean(options.lookerPermissionSet);
    this.projectId = StringHelper.clean(options.projectId);
    this.organizationList = StringHelper.clean(options.organizationList);


  }
}
